import _slicedToArray from "/codebuild/output/src145264479/src/LandingPage/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import { useComponentDefaultProps, UnstyledButton, Box, ChevronIcon } from '@mantine/core';
import { clamp } from '@mantine/hooks';
import useEmblaCarousel from 'embla-carousel-react';
import React, { forwardRef, useState, useCallback, useEffect, Children } from 'react';
import { CarouselProvider } from './Carousel.context.js';
import useStyles from './Carousel.styles.js';
import { CarouselSlide } from './CarouselSlide/CarouselSlide.js';
import { getChevronRotation } from './get-chevron-rotation.js';
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var __objRest = function __objRest(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols) {
    var _iterator2 = _createForOfIteratorHelper(__getOwnPropSymbols(source)),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var prop = _step2.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
  return target;
};
var defaultProps = {
  controlSize: 26,
  controlsOffset: "sm",
  slideSize: "100%",
  slideGap: 0,
  orientation: "horizontal",
  align: "center",
  slidesToScroll: 1,
  includeGapInSize: true,
  draggable: true,
  dragFree: false,
  loop: false,
  speed: 10,
  initialSlide: 0,
  inViewThreshold: 0,
  withControls: true,
  withIndicators: false,
  skipSnaps: false,
  containScroll: "",
  withKeyboardEvents: true
};
var _Carousel = forwardRef(function (props, ref) {
  var _a = useComponentDefaultProps("Carousel", defaultProps, props),
    children = _a.children,
    className = _a.className,
    getEmblaApi = _a.getEmblaApi,
    onNextSlide = _a.onNextSlide,
    onPreviousSlide = _a.onPreviousSlide,
    onSlideChange = _a.onSlideChange,
    nextControlLabel = _a.nextControlLabel,
    previousControlLabel = _a.previousControlLabel,
    controlSize = _a.controlSize,
    controlsOffset = _a.controlsOffset,
    classNames = _a.classNames,
    styles = _a.styles,
    unstyled = _a.unstyled,
    slideSize = _a.slideSize,
    slideGap = _a.slideGap,
    orientation = _a.orientation,
    height = _a.height,
    align = _a.align,
    slidesToScroll = _a.slidesToScroll,
    includeGapInSize = _a.includeGapInSize,
    draggable = _a.draggable,
    dragFree = _a.dragFree,
    loop = _a.loop,
    speed = _a.speed,
    initialSlide = _a.initialSlide,
    inViewThreshold = _a.inViewThreshold,
    withControls = _a.withControls,
    withIndicators = _a.withIndicators,
    plugins = _a.plugins,
    nextControlIcon = _a.nextControlIcon,
    previousControlIcon = _a.previousControlIcon,
    breakpoints = _a.breakpoints,
    skipSnaps = _a.skipSnaps,
    containScroll = _a.containScroll,
    withKeyboardEvents = _a.withKeyboardEvents,
    variant = _a.variant,
    others = __objRest(_a, ["children", "className", "getEmblaApi", "onNextSlide", "onPreviousSlide", "onSlideChange", "nextControlLabel", "previousControlLabel", "controlSize", "controlsOffset", "classNames", "styles", "unstyled", "slideSize", "slideGap", "orientation", "height", "align", "slidesToScroll", "includeGapInSize", "draggable", "dragFree", "loop", "speed", "initialSlide", "inViewThreshold", "withControls", "withIndicators", "plugins", "nextControlIcon", "previousControlIcon", "breakpoints", "skipSnaps", "containScroll", "withKeyboardEvents", "variant"]);
  var _useStyles = useStyles({
      controlSize: controlSize,
      controlsOffset: controlsOffset,
      orientation: orientation,
      height: height,
      includeGapInSize: includeGapInSize,
      breakpoints: breakpoints,
      slideGap: slideGap
    }, {
      name: "Carousel",
      classNames: classNames,
      styles: styles,
      unstyled: unstyled,
      variant: variant
    }),
    classes = _useStyles.classes,
    cx = _useStyles.cx,
    theme = _useStyles.theme;
  var _useEmblaCarousel = useEmblaCarousel({
      axis: orientation === "horizontal" ? "x" : "y",
      direction: orientation === "horizontal" ? theme.dir : void 0,
      startIndex: initialSlide,
      loop: loop,
      align: align,
      slidesToScroll: slidesToScroll,
      draggable: draggable,
      dragFree: dragFree,
      speed: speed,
      inViewThreshold: inViewThreshold,
      skipSnaps: skipSnaps,
      containScroll: containScroll
    }, plugins),
    _useEmblaCarousel2 = _slicedToArray(_useEmblaCarousel, 2),
    emblaRefElement = _useEmblaCarousel2[0],
    embla = _useEmblaCarousel2[1];
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    selected = _useState2[0],
    setSelected = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    slidesCount = _useState4[0],
    setSlidesCount = _useState4[1];
  var handleScroll = useCallback(function (index) {
    return embla && embla.scrollTo(index);
  }, [embla]);
  var handleSelect = useCallback(function () {
    if (!embla) return;
    var slide = embla.selectedScrollSnap();
    setSelected(slide);
    onSlideChange == null ? void 0 : onSlideChange(slide);
  }, [embla, setSelected]);
  var handlePrevious = useCallback(function () {
    embla == null ? void 0 : embla.scrollPrev();
    onPreviousSlide == null ? void 0 : onPreviousSlide();
  }, [embla]);
  var handleNext = useCallback(function () {
    embla == null ? void 0 : embla.scrollNext();
    onNextSlide == null ? void 0 : onNextSlide();
  }, [embla]);
  var handleKeydown = useCallback(function (event) {
    if (withKeyboardEvents) {
      if (event.key === "ArrowRight") {
        event.preventDefault();
        handleNext();
      }
      if (event.key === "ArrowLeft") {
        event.preventDefault();
        handlePrevious();
      }
    }
  }, [embla]);
  useEffect(function () {
    if (embla) {
      getEmblaApi == null ? void 0 : getEmblaApi(embla);
      handleSelect();
      setSlidesCount(embla.scrollSnapList().length);
      embla.on("select", handleSelect);
      return function () {
        embla.off("select", handleSelect);
      };
    }
    return void 0;
  }, [embla, slidesToScroll]);
  useEffect(function () {
    if (embla) {
      embla.reInit();
      setSlidesCount(embla.scrollSnapList().length);
      setSelected(function (currentSelected) {
        return clamp(currentSelected, 0, Children.toArray(children).length - 1);
      });
    }
  }, [Children.toArray(children).length, slidesToScroll]);
  var canScrollPrev = (embla == null ? void 0 : embla.canScrollPrev()) || false;
  var canScrollNext = (embla == null ? void 0 : embla.canScrollNext()) || false;
  var indicators = Array(slidesCount).fill(0).map(function (_, index) {
    return /* @__PURE__ */React.createElement(UnstyledButton, {
      key: index,
      "data-active": index === selected || void 0,
      className: classes.indicator,
      "aria-hidden": true,
      tabIndex: -1,
      onClick: function onClick() {
        return handleScroll(index);
      }
    });
  });
  return /* @__PURE__ */React.createElement(CarouselProvider, {
    value: {
      slideGap: slideGap,
      slideSize: slideSize,
      embla: embla,
      orientation: orientation,
      includeGapInSize: includeGapInSize,
      breakpoints: breakpoints,
      classNames: classNames,
      styles: styles,
      unstyled: unstyled,
      variant: variant
    }
  }, /* @__PURE__ */React.createElement(Box, __spreadValues({
    className: cx(classes.root, className),
    ref: ref,
    onKeyDownCapture: handleKeydown
  }, others), /* @__PURE__ */React.createElement("div", {
    className: classes.viewport,
    ref: emblaRefElement
  }, /* @__PURE__ */React.createElement("div", {
    className: classes.container
  }, children)), withIndicators && /* @__PURE__ */React.createElement("div", {
    className: classes.indicators
  }, indicators), withControls && /* @__PURE__ */React.createElement("div", {
    className: classes.controls
  }, /* @__PURE__ */React.createElement(UnstyledButton, {
    onClick: handlePrevious,
    className: classes.control,
    "aria-label": previousControlLabel,
    "data-inactive": !canScrollPrev || void 0,
    tabIndex: canScrollPrev ? 0 : -1
  }, typeof previousControlIcon !== "undefined" ? previousControlIcon : /* @__PURE__ */React.createElement(ChevronIcon, {
    style: {
      transform: "rotate(".concat(getChevronRotation({
        dir: theme.dir,
        orientation: orientation,
        direction: "previous"
      }), "deg)")
    }
  })), /* @__PURE__ */React.createElement(UnstyledButton, {
    onClick: handleNext,
    className: classes.control,
    "aria-label": nextControlLabel,
    "data-inactive": !canScrollNext || void 0,
    tabIndex: canScrollNext ? 0 : -1
  }, typeof nextControlIcon !== "undefined" ? nextControlIcon : /* @__PURE__ */React.createElement(ChevronIcon, {
    style: {
      transform: "rotate(".concat(getChevronRotation({
        dir: theme.dir,
        orientation: orientation,
        direction: "next"
      }), "deg)")
    }
  })))));
});
_Carousel.Slide = CarouselSlide;
_Carousel.displayName = "@mantine/carousel/Carousel";
var Carousel = _Carousel;
export { Carousel, _Carousel };